import React from 'react';
import BenefitSectionBox from "@product/features/benefitsection/index.ts";
import {BenefitSectionItemAttributes} from "@product/features/benefitsection/benefit-section-item-attribute.ts";
import {Typography} from "@bonprix/design-system";

export default function BenefitSection({product, fullWidth}) {
    const getHideIfMissingAttributes = (product) => {
        const hideIfMissing = [];

        // for better understanding, there are two chained if statements
        if (!product.currentItemOption) {
            if (product.currentItem?.itemOptions.some(option => !option.parcelShopDelivery)) {
                hideIfMissing.push(BenefitSectionItemAttributes.PARCEL_SHOP_DELIVERY);
            }
        } else {
            if (!product.currentItemOption.parcelShopDelivery) {
                hideIfMissing.push(BenefitSectionItemAttributes.PARCEL_SHOP_DELIVERY);
            }
        }
        return hideIfMissing;
    };

    const hideIfMissing = getHideIfMissingAttributes(product);

    return (
        <div className={fullWidth ? "product__benefit-section__full_width" : "product__benefit-section"}>
            <BenefitSectionBox items={product?.benefitSection?.items || []} hideIfMissing={hideIfMissing}/>
        </div>
    );
}
